import React, { useState, useEffect } from "react";
import "./UsuarioList.css";
import Usuario from "../supabase/Usuario";
import logo from "../Nido/logo.png";
import {useNavigate} from "react-router-dom";
import {useAuth} from "../../context/AuthContext";

export default function UsuarioList() {
    const navigate = useNavigate();
    const { user, logout } = useAuth();
    const [search, setSearch] = useState("");
    const [usuarios, setUsuarios] = useState([]);

    // Fetch all users on mount
    useEffect(() => {
        async function fetchData() {
            const data = await Usuario.getUsers();
            if (data) {
                const activeUsers = data.filter((u) => u.numDocumento !== user.numDocumento);
                setUsuarios(activeUsers)
            }
        }
        fetchData();
    }, [user]);

    // Handle search input
    const handleSearch = (e) => {
        setSearch(e.target.value.toLowerCase());
    };

    const handleLogout = () => {
        logout();
        navigate('/');
    };

    const handleDelete = async (numDocumento) => {
        if (!window.confirm("¿Estás seguro de eliminar este usuario?")) return;

        try {
            await Usuario.updateState(numDocumento)

        } catch (err) {
            console.error(err);
            alert("Error al eliminar el usuario");
        }
    };

    const filteredUsuarios = usuarios.filter(
        (u) =>
            u.Usuario?.toLowerCase().includes(search) ||
            u.Correo?.toLowerCase().includes(search)
    );

    return (
        <div className="app-container">
            <div className="usuario-view-page">
                <header className="topbar">
                <div className="brand">
                    <img src={logo} alt="logo" className="brand-logo" />
                    <nav className="nav">
                        <button className="nav-link" onClick={() => navigate('/home')}>Inicio</button>
                        <button className="nav-link active" onClick={() => navigate('/profile')}>Mi nido</button>
                    </nav>
                    <button className="logout-btn" onClick={handleLogout} title="Cerrar sesión">↪</button>
                </div>
                    <title>ReANIDArt - Administrar usuarios</title>
            </header>
                <div className="search-bar">
                    <input
                        type="text"
                        placeholder="Buscar"
                        value={search}
                        onChange={handleSearch}
                    />
                    <button className="icon">🔍</button>
                </div>

                <main className="usuario-list">
                    {filteredUsuarios.length > 0 ? (
                        filteredUsuarios.map((user) => (
                            <div className="usuario-card" key={user.numDocumento}>
                                <div className="usuario-info">
                                    <div className="avatar">
                                        {user.Usuario?.charAt(0).toUpperCase()}
                                    </div>
                                    <div className="details">
                                        <span className="username">{user.Usuario}</span>
                                        <span className="email">{user.Correo || "Sin correo"}</span>
                                        <span className="state">{user.activo ? "activo" : "inactivo"}</span>
                                    </div>
                                </div>
                                <button
                                    className="delete-btn"
                                    onClick={() => handleDelete(user.numDocumento)}
                                >
                                    Eliminar
                                </button>
                            </div>
                        ))
                    ) : (
                        <p className="no-results">No se encontraron usuarios.</p>
                    )}
                </main>
            </div>
        </div>
    );
}
